<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="px-3 board-header">
      <div class="col-12" style="padding: 0px 10px">
        <h4>{{ $t('reports.cxiReport2024.reportHeader1') }}</h4>
        {{ $t('reports.cxiReport2024.reportHeader2') }} <br/>
        {{ $t('reports.cxiReport2024.reportHeader3') }}
      </div>
      <div class="row mt-4">
        <div class="col-4" style="padding: 0px 10px">
          <div class="col-12 board-border">
            <div class="col-12" style="display: flex">
              <div style="min-width: 100%">
                <div class="nps-display">
                  <div class="idx-card-title">
                    {{ $t('reports.cxiReport2024.graphicTitle') }}
                  </div>
                  <div class="nps-chart">
                    <radial-progress-bar
                      v-if="cxiScore !== null && cxiScore !== undefined"
                      :diameter="240"
                      :stroke-width="20"
                      innerStrokeColor="#f1f1f1"
                      :startColor="colorBalance"
                      :stopColor="colorBalance"
                      :completed-steps="
                        completedSteps ? parseFloat(completedSteps) : 0
                      "
                      :total-steps="totalSteps"
                    >
                      <b
                        id="number-cxi"
                        :style="{
                          color: colorBalance,
                          fontSize: '2.8em',
                          fontWeight: 'bold',
                        }"
                        >{{ completedSteps.toFixed(2) }}</b
                      >
                      <b-tooltip
                        v-if="cxiScore !== null && cxiScore !== undefined"
                        target="number-cxi"
                        placement="bottom"
                      >
                        {{ $t('reports.cxiReport2024.cxiLabel') }}
                        <strong>{{ cxiScore }}</strong>
                      </b-tooltip>
                    </radial-progress-bar>
                    <div v-else>
                      {{ $t('reports.cxiReport2024.noDataMsg') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8" style="padding: 0px 10px">
          <div class="col-12 board-border" style="padding: 0px 10px">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <b-table
            :fields="fieldsA"
            :items="itemsA"
            caption-bottom
            sort-icon-left
            :per-page="10"
            :current-page="currentPageA"
          >
            <template v-slot:cell(question)="row">
              {{ row.item.question }}
            </template>
            <template v-slot:cell(averageReview)="row">
              {{
                row.item.averageReview ? row.item.averageReview.toFixed(2) : '-'
              }}
            </template>
          </b-table>

          <b-row>
            <b-col cols="10"></b-col>
            <b-col cols="1" class="text-left total-number">
              <strong>{{ totalA }}</strong>
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>

          <div class="footer">
            <b-pagination
              v-model="currentPageA"
              :total-rows="itemsA.length"
              :per-page="10"
            ></b-pagination>
          </div>
        </div>

        <div class="col-12">
          <br />
          <br />
          <b-table
            :fields="fieldsB"
            :items="itemsB"
            caption-bottom
            sort-icon-left
          >
            <template v-slot:cell(question)="row">
              {{ row.item.question }}
            </template>
            <template v-slot:cell(averageReview)="row">
              {{ row.item.averageReview.toFixed(2) }}
            </template>
          </b-table>

          <b-row>
            <b-col cols="10"></b-col>
            <b-col cols="1" class="text-left total-number">
              <strong>{{ totalB }}</strong>
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>

          <div class="footer">
            <b-pagination
              v-model="currentPageB"
              :total-rows="itemsB.length"
              :per-page="10"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import loader from '@/components/atoms/loader';
import api from '../../../../services/api';

export default {
  name: 'CxiReport2024',
  components: {
    RadialProgressBar,
    animatedNumber,
    loader,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    totalA: null,
    totalB: null,
    chartOptions: {
      title: {
        align: 'left',
        text: '',
        style: {
          color: '#5f6368',
        },
      },
      chart: {
        type: 'column',
        borderColor: 'rgba(0, 0, 0, 0.09)',
        style: {
          fontFamily:
            '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue"',
          fontSize: '12px',
          width: '100%',
          height: '350px',
        },
      },
      xAxis: {
        categories: [],
        visible: true,
        labels: {},
      },
      yAxis: {
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
        max: 5,
        title: {
          text: '',
        },
        stackLabels: {
          enabled: true,
          fontWeight: 'bold',
        },
      },
      series: [
        {
          name: 'Score',
          data: [],
        },
      ],
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0.1,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
          },
        },
        line: {
          dataLabels: {
            enabled: true,
          },
        },
        area: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          groupPadding: 0,
          pointPadding: 0.05,
          borderWidth: 0,
        },
      },
      colors: ['#4ce595'],
    },
    completedSteps: null,
    totalSteps: 100,
    colorBalance: '#fff',
    fields: [],
    itemsA: [],
    itemsB: [],
    currentPageA: 1,
    currentPageB: 1,
    cxiScore: null,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getCxiData();
    },

    myActionId: function watchmyActionId() {
      this.getCxiData();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getCxiData();
    },

    calendarDates: function watchCalendarDates() {
      this.getCxiData();
    },

    myIh1: function watchMyIh1() {
      this.getCxiData();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getCxiData();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getCxiData();
    },

    myIh2: function watchMyIh2() {
      this.getCxiData();
    },

    myMetric: function watchMyMetric() {
      this.getCxiData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getCxiData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getCxiData();
    },
    '$i18n.locale': function watchLocale() {
      this.getCxiData();

      this.fieldsA = [
        {
          key: 'question',
          label: this.$t('reports.cxiReport2024.questionA'),
          sortable: true,
          class: 'custom-width',
        },
        {
          key: 'averageReview',
          label: this.$t('reports.cxiReport.score'),
          sortable: true,
          class: 'scoreTh',
        },
        {
          key: 'total',
          label: 'Total',
          sortable: true,
          class: 'totalTh',
        },
      ];
      this.fieldsB = [
        {
          key: 'question',
          label: this.$t('reports.cxiReport2024.questionB'),
          sortable: true,
          class: 'custom-width',
        },
        {
          key: 'averageReview',
          label: this.$t('reports.cxiReport.score'),
          sortable: true,
          class: 'scoreTh',
        },
        {
          key: 'total',
          label: 'Total',
          sortable: true,
          class: 'totalTh',
        },
      ];
    },
  },

  methods: {
    async renderChart(data) {
      this.chartOptions = {
        title: {
          align: 'left',
          text: this.$t('reports.cxiReport2024.cxiLabel'),
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          borderColor: 'rgba(0, 0, 0, 0.09)',
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
            width: '100%',
          },
        },
        xAxis: {
          categories: data.categories,
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 100,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: this.$t('reports.cxiReport2024.cxiLabel'),
            data: data.series,
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          area: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ['#4ce595'],
      };
    },

    async chartEmpty() {
      if (this.cxi.categories.length === 0) {
        this.chartOptions = {
          title: {
            align: 'left',
            text: this.$t('reports.cxiReport.reportTitle'),
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: this.type,
            borderColor: 'rgba(0, 0, 0, 0.09)',
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
        };
      }
    },

    async getCxiData() {
      this.loading = true;

      let response = null;

      const headers = {
        'x-access-token': this.userAuth.token,
      };
      const params = {
        actionId:
          this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        startDate: this.calendarDates.start,
        endDate: this.calendarDates.end,
        ih1:
          this.myHierarchies1.length === 0
            ? null
            : this.myHierarchies1.join(','),
        ih2:
          this.myHierarchies2.length === 0
            ? null
            : this.myHierarchies2.join(','),
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      };

      response = await api.get('/reports/cxi-v2', {
        headers: { ...headers },
        params: { ...params },
      });

      // Extraindo as chaves e ordenando-as
      this.chartOptions.xAxis.categories = Object.keys(
        response.data.cxiByMonth,
      ).sort((a, b) => {
        // Separando mês e ano para comparação
        const [monthA, yearA] = a.split('/').map(Number);
        const [monthB, yearB] = b.split('/').map(Number);

        // Comparando primeiro os anos, depois os meses
        if (yearA !== yearB) {
          return yearA - yearB;
        }
        return monthA - monthB;
      });

      // Extraindo os valores na ordem das chaves ordenadas
      this.chartOptions.series[0].data = this.chartOptions.xAxis.categories.map(
        (key) => Number(response.data.cxiByMonth[key].toFixed(2)),
      );

      this.itemsA = response.data.calculationA.questions;
      this.itemsB = response.data.calculationB.questions;
      this.totalA = response.data.finalAverageReviewA
        ? response.data.finalAverageReviewA.toFixed(2)
        : 0;
      this.totalB = response.data.finalAverageReviewB
        ? response.data.finalAverageReviewB.toFixed(2)
        : 0;

      this.cxiScore = response.data.finalCXI;
      this.completedSteps = this.cxiScore;

      this.setColorCxi(this.completedSteps);
      this.renderChart({
        categories: this.chartOptions.xAxis.categories,
        series: this.chartOptions.series[0].data,
      });

      this.loading = false;
    },

    setColor(score) {
      if (score >= 4) {
        return '#6bca6c';
      } else if (score < 4 && score >= 3) {
        return '#9fd77a';
      } else if (score < 3 && score >= 2) {
        return '#fbcf3f';
      } else if (score < 2 && score >= 1) {
        return '#fa834f';
      }
      return 'red';
    },

    setColorCxi(percentBalace) {
      if (percentBalace >= 80) {
        this.colorBalance = '#6bca6c';
      } else if (percentBalace < 80 && percentBalace >= 70) {
        this.colorBalance = '#9fd77a';
      } else if (percentBalace < 70 && percentBalace >= 50) {
        this.colorBalance = '#fbcf3f';
      } else if (percentBalace < 50 && percentBalace >= 20) {
        this.colorBalance = '#fa834f';
      } else if (percentBalace < 20) {
        this.colorBalance = 'red';
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fieldsA = [
      {
        key: 'question',
        label: this.$t('reports.cxiReport2024.questionA'),
        sortable: true,
        class: 'custom-width',
      },
      {
        key: 'averageReview',
        label: this.$t('reports.cxiReport.score'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'total',
        label: 'Total',
        sortable: true,
        class: 'totalTh',
      },
    ];
    this.fieldsB = [
      {
        key: 'question',
        label: this.$t('reports.cxiReport2024.questionB'),
        sortable: true,
        class: 'custom-width',
      },
      {
        key: 'averageReview',
        label: this.$t('reports.cxiReport.score'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'total',
        label: 'Total',
        sortable: true,
        class: 'totalTh',
      },
    ];
  },

  async mounted() {
    this.loading = true;
    await this.getCxiData();
    this.loading = false;
  },
};
</script>

<style lang="scss">
.total-number {
  font-weight: 700;
  font-size: 20px;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-top: 10px;
}

.custom-width {
  width: 85%;
}

#number-cxi {
  font-size: 50px !important;
}
.scoreTh {
  width: 70px;
  padding-right: 0px !important;
}

.questionTh {
  width: calc(100% - 200px);
}
</style>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nps-display {
  border: none !important;
}

.board-border {
  border: 1px solid #eee;
}

.board-header h1 {
  font-size: 16px;
}

.radial-progress-inner {
  justify-content: center;
  font-size: 3.2em;
  cursor: pointer;
}

.nps-display {
  border: 1px solid $gray-light;
  padding: 18px 0;
  flex-direction: column;
  border-radius: 4px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }
  .nps-chart {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/cxi-report-2024/index.vue